//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import arrowGo from "../../../svg/arrowGo.vue";
import arrowBack from "../../../svg/arrowBack.vue";
import community from "../../../svg/community.vue";
import communityActivity from "../../../svg/communityActivity.vue";
import communityPlugin from "../../../svg/communityPlugin.vue";
import login from "../login.vue";
import menuClientDatas from "./menu-client.json";

export default {
  components: {
    arrowGo,
    arrowBack,
    community,
    communityActivity,
    communityPlugin,
    login,
  },
  inject: ["jumpCallBack", "sensors", "action"],
  mounted() {
    const { ipcRenderer } = window.require("electron");
    ipcRenderer.on("did-navigate-in-page", this.handleNav);
  },
  data() {
    return {
      canGoBack: true,
      canGoForward: false,
    };
  },
  computed: {
    datas() {
      return menuClientDatas.map((v) => {
        v.path = v.path.replace("$origin$", location.origin);
        return v;
      });
    },
  },
  methods: {
    handleNav(e, playload) {
      const { canGoBack, canGoForward } = playload;
      this.canGoBack = canGoBack;
      this.canGoForward = canGoForward;
    },
    handle(menu) {
      if (this.sensors) {
        const trackDatas = {
          action_parameter1: "header",
          action_type: "click",
          ...menu.eventId,
        };
        Object.assign(trackDatas, this.action);
        this.sensors.track("event_click", trackDatas);
      }
      menu.path = menu.path.replace("$origin$", location.origin);
      // item 点击跳转
      if (this.jumpCallBack) {
        this.jumpCallBack(menu, this.toPath);
      } else {
        this.toPath(menu.path);
      }
    },
    toPath(path) {
      if (path && path.indexOf("http") === 0) {
        window.open(path, "_blank");
      } else if (path) {
        this.$router?.push(path);
      } else {
        const { path } = this.datas;
        this.$router?.push(path);
      }
    },
    handleBack() {
      if (this.canGoBack) {
        history.back();
      }
    },
    handleGo() {
      if (this.canGoForward) {
        history.forward();
      }
    },
    menuActivate(menu) {
      const origin = location.origin;
      const path = menu.path.split(`${origin}/community`)[1] || '/';
      let matched = path === this.$route.path;
      if (!matched && menu.innerPagesPrefix) {
        matched |= menu.innerPagesPrefix.some((v) => this.$route.path.startsWith(v));
      }
      return matched;
    },
  },
};
